import { createTheme, rem } from '@mantine/core';

export const mantineTheme = createTheme({
  fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  fontFamilyMonospace: "'JetBrains Mono', ui-monospace, monospace",

  primaryColor: 'violet',
  primaryShade: 7,

  colors: {
    brand: [
      '#EDE9FE',
      '#DDD6FE',
      '#C4B5FD',
      '#A78BFA',
      '#8B5CF6',
      '#7C3AED',
      '#6D28D9',
      '#5B21B6',
      '#4C1D95',
      '#2D00F7',
    ],
  },

  defaultRadius: 'md',

  headings: {
    fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
    fontWeight: '800',
  },

  components: {
    Button: {
      defaultProps: {
        radius: 'xl',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'xl',
      },
    },
    Badge: {
      defaultProps: {
        radius: 'xl',
      },
    },
  },

  other: {
    // Fairmint brand tokens — keep in sync with globals.css
    brandBlue:   '#2D00F7',
    brandPurple: '#8900F2',
    deep:        '#1A1F36',
    slate:       '#64748B',
  },

  spacing: {
    xs: rem(8),
    sm: rem(12),
    md: rem(16),
    lg: rem(20),
    xl: rem(28),
  },
});
